module.exports = __webpack_public_path__ + "assets/ParallelogramVOn4LinesDetailed.c4a46b0522e0c4d54d3bc079817817d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/ParallelogramVOn4LinesDetailed.png
// module id = 548
// module chunks = 0